import _3PINVES_EXT_1 from "./3PINVES_EXT_1";

export default {
  _3PINVES_EXT_1,
};
